/* eslint-disable import/prefer-default-export */
export const PHONE_NUMBER_MAX_LENGTH = 100;
export const EMPLOYEE_LOCATION_MAX_LENGTH = 250;
export const EMPLOYEE_WORKING_HOURS_MAX_LENGTH = 100;
